import { useState, useEffect } from 'react'
import { FaPlusCircle } from 'react-icons/fa'
import { AddButton } from 'components/common/AddButton'
import { AddChecklistModal } from './AddChecklistModal'
import { Checklist } from './Checklist'

const ChecklistsContainer = ({
  checklists,
  addItem,
  deleteChecklist,
  deleteItem,
  updateItem,
  createChecklist,
  updateChecklist
}) => {
  const [isAddChecklistModalVisible, setIsAddChecklistModalVisible] = useState(false)
  const [editedChecklist, setEditedChecklist] = useState(null)
  const [editedItem, setEditedItem] = useState(null)

  useEffect(() => {
    setIsAddChecklistModalVisible(!!editedChecklist)
  }, [editedChecklist])

  useEffect(() => {
    setIsAddChecklistModalVisible(!!editedItem)
  }, [editedItem])

  const toggleAddChecklistModal = () => {
    setIsAddChecklistModalVisible(!isAddChecklistModalVisible)
    setEditedChecklist(null)
    setEditedItem(null)
  }

  return (
    <>
      <AddButton onClick={toggleAddChecklistModal}>
        <FaPlusCircle />
        Add Checklist
      </AddButton>
      {checklists.map(checklist => (
        <Checklist
          checklist={checklist}
          key={checklist.id}
          addItem={addItem}
          deleteItem={deleteItem}
          deleteChecklist={deleteChecklist}
          setEditedChecklist={setEditedChecklist}
          setEditedItem={setEditedItem}
        />
      ))}
      {isAddChecklistModalVisible && (
        <AddChecklistModal
          toggleAddChecklistModal={toggleAddChecklistModal}
          isAddChecklistModalVisible={isAddChecklistModalVisible}
          createChecklist={createChecklist}
          editedChecklist={editedChecklist}
          updateChecklist={updateChecklist}
          editedItem={editedItem}
          updateItem={updateItem}
        />
      )}
    </>
  )
}

export default ChecklistsContainer
